export const statusConstants = () => {
  const request = {
    active: "active",
    denied: "denied",
    pending: "pending",
    complete: "complete",
    cancelled: "cancelled",
    hidden: "hidden",
  };
  const commitment = {
    outstanding: "outstanding",
    ready: "ready",
    complete: "complete",
    cancelled: "cancelled",
  };
  const visibleAdminCategories = [
    "pending",
    "active",
    "denied",
    "complete",
    "hidden",
    "cancelled",
  ];
  const visibleSewistCategories = ["active"];
  return {
    request,
    commitment,
    visibleAdminCategories,
    visibleSewistCategories,
  };
};
